import { ArrowLeft } from 'lucide-react';

import useApplyBackButton from './useApplyBackButton';

const ApplyBackButton: React.FunctionComponent = function () {
  const { onBackClick, title } = useApplyBackButton();
  return (
    <button
      className="flex flex-row gap-x-2 hover:bg-neutral-300 w-max px-3 md:px-4 py-2 rounded-full text-14-22 text-neutral-700"
      onClick={onBackClick}
      id="apply-back"
      type="button"
    >
      <ArrowLeft size={22} />
      {title}
    </button>
  );
};

export default ApplyBackButton;
